export default __webpack_public_path__ + "static/media/al.ae05a58c.svg";